import React, { useState } from "react";

import { Box, Typography, Paper } from "@mui/material";
import personMore from "../../../assets/images/SVG/personMore.svg"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AcessAdjustModal from "../AcessAdjustModal";

const LinkProfessionalBanner = () => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <Paper
                onClick={(e) => { e.stopPropagation(); setModalOpen(true); }}
                variant="outlined"
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    marginBottom: "12px",
                    borderRadius: "12px",
                    borderStyle: "dashed",
                    borderColor: "#662D91",
                    backgroundColor: "#F9F5FF",
                    padding: "16px 20px",
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#F0E8FA" },
                    "&:hover .default-text": { display: "none" },
                    "&:hover .hover-text": { display: "block !important" }
                }}
            >
                <Box>
                    <Box sx={{ width: "60px", height: "60px" }}>
                        <img src={personMore} alt="Usuarios" width="100%" height="100%" />
                    </Box>
                    <Box>
                        <Typography fontWeight={600} fontSize="16.14px" marginBlock="12px">
                            Vincule-se a um profissional
                        </Typography>

                        <Typography
                            className="hover-text"
                            sx={{
                                display: "none",
                                color: "#662D91",
                                fontWeight: 700,
                                textDecoration: "underline",
                                fontSize: "15px"
                            }}
                        >
                            Mais informações
                        </Typography>
                    </Box>
                </Box>
                <ArrowForwardIcon />
            </Paper>
            <AcessAdjustModal open={modalOpen} onClose={() => setModalOpen(false)} />
        </>
    )
}

export default LinkProfessionalBanner;